import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { __OBJECT_STRUCTURE_GetGAP } from '../../../../../../common/ObjectStructures/sKPI';
import { __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import moment from 'moment';

function ELEMENT_CONTRACT_LAST_EDP(props) {
    const { t } = useTranslation();

    const { 
        inputParam_HideHeader = false,
        inputParam_ComponentContent = null,
        inputParam_UseFake = false,
    } = props;

    const data = !inputParam_UseFake ? inputParam_ComponentContent : {
        item: {
            confAdn: '--',
            fechaDesde: '--',
            fechaHasta: '--',
        }
    }

    const renderContent = () => {
        return  <Row className='px-3 h-100'>
                    <Col xl={3} className="border rounded text-center d-flex align-items-center justify-content-center" style={{ color: 'white', backgroundColor: '#84B681' }}>
                        <div className='font-weight-bold' style={{fontSize: "18px"}}>EP {data !== null && data.item !== null ? data.item.etapaFlujo : '--'}</div>
                    </Col>
                    <Col>
                        <Row className='border ms-1'>
                            <Col>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col>{t('data-lang-lbl-responsible')}</Col>
                                        </Row>
                                        <Row>
                                            <Col className='font-weight-bold'>{data !== null && data.item !== null && data.item.confAdn != null ? (data.item.confAdn.indexOf('i:0#.f|fbamembership|') !== -1 ? data.item.confAdn.split('\\')[1] : data.item.confAdn) : '--'}</Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row className='border' style={{backgroundColor: '#efefef'}}>
                                            <Col style={{fontSize: "18px"}}>{`${t('data-lang-lbl-epnumber-large')}: ${data !== null && data.item !== null ? data.item.nroEp : '--'}`}</Col>
                                        </Row>
                                        <Row className='border' style={{backgroundColor: '#efefef'}}>
                                            <Col style={{fontSize: "18px"}}>{t('data-lang-lbl-epcollectionperiod')}</Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Row>
                                                    <Col>{t('data-lang-lbl-datefrom')}</Col>
                                                </Row>
                                                <Row>
                                                    <Col className='font-weight-bold'>{data !== null && data.item !== null ? moment(data.item.fechaDesde).format('DD-MM-YYYY') : '--'}</Col>
                                                </Row>
                                            </Col>
                                            <Col>
                                                <Row>
                                                    <Col>{t('data-lang-lbl-dateuntil')}</Col>
                                                </Row>
                                                <Row>
                                                    <Col className='font-weight-bold'>{data !== null && data.item !== null ? moment(data.item.fechaHasta).format('DD-MM-YYYY') : '--'}</Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
    }

    return (
        <>
        {
            !inputParam_UseFake &&
            <Card className='h-100'>
                {
                    !inputParam_HideHeader &&
                    <Card.Header className="card-header-compact">
                        <Card.Title className="d-flex justify-content-between">
                            <b>{ data !== null && data.boardComponentTitle !== null ? data.boardComponentTitle : t('data-lang-boxname-currentstatus')}</b>
                            <div className='toolbar d-flex'>
                            </div>
                        </Card.Title>
                    </Card.Header>
                }
                <Card.Body className='px-1 h-100'>
                    {renderContent()}
                </Card.Body>
            </Card>
        }
        {
            inputParam_UseFake && renderContent()
        }
        </>
            
      );
}

ELEMENT_CONTRACT_LAST_EDP.propTypes = {
};

export default ELEMENT_CONTRACT_LAST_EDP;